// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Subscription-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
}

.Subscription-back-row {
  width: 100%;
  max-width: 1200px;
  margin: 16px auto 0;
  padding: 0 16px;
}

.Subscription-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 6px 12px;
  font-family: "NotoSansMalayalam-SemiBold";
  font-size: 13px;
  color: #444;
  cursor: pointer;
  transition: all 0.2s ease;
}
.Subscription-back-btn:hover {
  background: #f0f4f8;
  color: rgb(5, 118, 183);
  border-color: rgb(5, 118, 183);
}

.Subscription-layout {
  display: flex;
  flex: 1 1;
  width: 100%;
  max-width: 1200px;
  margin: 16px auto 24px;
  padding: 0 16px;
  gap: 24px;
}
@media screen and (max-width: 768px) {
  .Subscription-layout {
    flex-direction: column;
    margin: 12px auto;
    gap: 12px;
  }
}

.Subscription-sidebar {
  width: 240px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  padding: 12px;
  height: fit-content;
}
@media screen and (max-width: 768px) {
  .Subscription-sidebar {
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 8px;
    gap: 8px;
  }
}

.Subscription-sidebar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-family: "NotoSansMalayalam-SemiBold";
  font-size: 14px;
  color: #444;
  background: transparent;
  border: none;
  width: 100%;
  text-align: left;
  transition: all 0.2s ease;
}
.Subscription-sidebar-item:hover {
  background: #f0f4f8;
  color: rgb(5, 118, 183);
}
.Subscription-sidebar-item.active {
  background: rgba(0, 162, 255, 0.0941176471);
  color: rgb(5, 118, 183);
  font-family: "NotoSansMalayalam-Bold";
}
@media screen and (max-width: 768px) {
  .Subscription-sidebar-item {
    flex: 1 1;
    justify-content: center;
  }
}

.Subscription-content {
  flex: 1 1;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  padding: 24px;
  min-height: 400px;
}
@media screen and (max-width: 768px) {
  .Subscription-content {
    padding: 16px;
  }
}

.Subscription-content-title {
  font-family: "NotoSansMalayalam-Bold";
  font-size: 20px;
  color: #222;
  margin-bottom: 16px;
}

.Subscription-detail-card {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 18px;
  margin-bottom: 16px;
  background: #fafbfc;
}

.Subscription-renew-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid #d0e8f8;
  background: #f5f9fe;
  border-radius: 8px;
  padding: 18px 20px;
}
.Subscription-renew-block.expiring {
  border-color: #ffd591;
  background: #fff7e6;
}
.Subscription-renew-block.expired {
  border-color: #ffa39e;
  background: #fff1f0;
}
@media screen and (max-width: 600px) {
  .Subscription-renew-block {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
}

.Subscription-renew-text {
  flex: 1 1;
}

.Subscription-renew-title {
  font-family: "NotoSansMalayalam-Bold";
  font-size: 15px;
  color: #222;
  margin-bottom: 4px;
}

.Subscription-renew-sub {
  font-family: "NotoSansMalayalam-Regular";
  font-size: 13px;
  color: #666;
}

.Subscription-detail-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed #eee;
}
.Subscription-detail-row:last-child {
  border-bottom: none;
}
@media screen and (max-width: 480px) {
  .Subscription-detail-row {
    flex-direction: column;
    gap: 4px;
  }
}

.Subscription-detail-label {
  font-family: "NotoSansMalayalam-SemiBold";
  font-size: 13px;
  color: #666;
}

.Subscription-detail-value {
  font-family: "NotoSansMalayalam-SemiBold";
  font-size: 13px;
  color: #222;
  text-align: right;
}
@media screen and (max-width: 480px) {
  .Subscription-detail-value {
    text-align: left;
  }
}

.Subscription-empty {
  text-align: center;
  padding: 48px 24px;
  color: #888;
  font-family: "NotoSansMalayalam-SemiBold";
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/screens/settings/styles.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yCAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;AACF;AACE;EACE,mBAAA;EACA,uBAAA;EACA,8BAAA;AACJ;;AAGA;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,SAAA;AAAF;AAEE;EATF;IAUI,sBAAA;IACA,iBAAA;IACA,SAAA;EACF;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EATF;IAUI,WAAA;IACA,aAAA;IACA,mBAAA;IACA,YAAA;IACA,QAAA;EAEF;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yCAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;AAEF;AAAE;EACE,mBAAA;EACA,uBAAA;AAEJ;AACE;EACE,2CAAA;EACA,uBAAA;EACA,qCAAA;AACJ;AAEE;EA3BF;IA4BI,SAAA;IACA,uBAAA;EACF;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,aAAA;EACA,iBAAA;AACF;AACE;EARF;IASI,aAAA;EAEF;AACF;;AACA;EACE,qCAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAEF;;AACA;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAEF;AAAE;EACE,qBAAA;EACA,mBAAA;AAEJ;AACE;EACE,qBAAA;EACA,mBAAA;AACJ;AAEE;EApBF;IAqBI,sBAAA;IACA,oBAAA;IACA,SAAA;EACF;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,qCAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,wCAAA;EACA,eAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,8BAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EAVF;IAWI,sBAAA;IACA,QAAA;EACF;AACF;;AAEA;EACE,yCAAA;EACA,eAAA;EACA,WAAA;AACF;;AAEA;EACE,yCAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AACF;AACE;EANF;IAOI,gBAAA;EAEF;AACF;;AACA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,yCAAA;EACA,eAAA;AAEF","sourcesContent":[".Subscription-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: #f5f7fa;\n}\n\n.Subscription-back-row {\n  width: 100%;\n  max-width: 1200px;\n  margin: 16px auto 0;\n  padding: 0 16px;\n}\n\n.Subscription-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: transparent;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  font-size: 13px;\n  color: #444;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #f0f4f8;\n    color: rgb(5, 118, 183);\n    border-color: rgb(5, 118, 183);\n  }\n}\n\n.Subscription-layout {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  max-width: 1200px;\n  margin: 16px auto 24px;\n  padding: 0 16px;\n  gap: 24px;\n\n  @media screen and (max-width: 768px) {\n    flex-direction: column;\n    margin: 12px auto;\n    gap: 12px;\n  }\n}\n\n.Subscription-sidebar {\n  width: 240px;\n  flex-shrink: 0;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  padding: 12px;\n  height: fit-content;\n\n  @media screen and (max-width: 768px) {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    padding: 8px;\n    gap: 8px;\n  }\n}\n\n.Subscription-sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  font-size: 14px;\n  color: #444;\n  background: transparent;\n  border: none;\n  width: 100%;\n  text-align: left;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #f0f4f8;\n    color: rgb(5, 118, 183);\n  }\n\n  &.active {\n    background: #00a2ff18;\n    color: rgb(5, 118, 183);\n    font-family: \"NotoSansMalayalam-Bold\";\n  }\n\n  @media screen and (max-width: 768px) {\n    flex: 1;\n    justify-content: center;\n  }\n}\n\n.Subscription-content {\n  flex: 1;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  padding: 24px;\n  min-height: 400px;\n\n  @media screen and (max-width: 768px) {\n    padding: 16px;\n  }\n}\n\n.Subscription-content-title {\n  font-family: \"NotoSansMalayalam-Bold\";\n  font-size: 20px;\n  color: #222;\n  margin-bottom: 16px;\n}\n\n.Subscription-detail-card {\n  border: 1px solid #eee;\n  border-radius: 8px;\n  padding: 18px;\n  margin-bottom: 16px;\n  background: #fafbfc;\n}\n\n.Subscription-renew-block {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  border: 1px solid #d0e8f8;\n  background: #f5f9fe;\n  border-radius: 8px;\n  padding: 18px 20px;\n\n  &.expiring {\n    border-color: #ffd591;\n    background: #fff7e6;\n  }\n\n  &.expired {\n    border-color: #ffa39e;\n    background: #fff1f0;\n  }\n\n  @media screen and (max-width: 600px) {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n}\n\n.Subscription-renew-text {\n  flex: 1;\n}\n\n.Subscription-renew-title {\n  font-family: \"NotoSansMalayalam-Bold\";\n  font-size: 15px;\n  color: #222;\n  margin-bottom: 4px;\n}\n\n.Subscription-renew-sub {\n  font-family: \"NotoSansMalayalam-Regular\";\n  font-size: 13px;\n  color: #666;\n}\n\n.Subscription-detail-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px dashed #eee;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  @media screen and (max-width: 480px) {\n    flex-direction: column;\n    gap: 4px;\n  }\n}\n\n.Subscription-detail-label {\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  font-size: 13px;\n  color: #666;\n}\n\n.Subscription-detail-value {\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  font-size: 13px;\n  color: #222;\n  text-align: right;\n\n  @media screen and (max-width: 480px) {\n    text-align: left;\n  }\n}\n\n.Subscription-empty {\n  text-align: center;\n  padding: 48px 24px;\n  color: #888;\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
